import { TrackJsConfigService } from '@com-delta-idp/mnx-utils';
import { trackJsConfig } from '../models';

export const profileTrackJsConfigService = (): (() => TrackJsConfigService) => {
  return () => {
    return new TrackJsConfigService(trackJsConfig);
  };
};
